import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Modal} from "react-bootstrap";
import currentTheme from "../../../react-themes/theme";
import {t, useLocale, useEnsureTranslate} from "../../../shared-services/translate";
import {useSelector} from "../../../shared-services/redux-tiny";
import {mediaQuery} from "../../../react-components/shared/GlobalStyles";

const theme = currentTheme();
const imagePath = "/resources/farmy/images/components/modals/bye_lausanne";
const translationKey = "modals.lausanne_closure";
const newFarmyPassLink = "/farmypass/new";
const accountFarmyPass = "/account#farmypass_preferences";
const deliveryDetailsLink = {de: "/zipcode-versandkosten-details", "fr-CH": "/fr-CH/zone-details-des-frais-de-livraison", en: "/en/zone-delivery-cost-details"};
const ByeLausanneModal = (props) => {
  useEnsureTranslate();
  const locale = useLocale();
  const [showModal, setShowModal] = useState(false);
  const [delivery, setDelivery] = useState(true);
  const sessionContext = useSelector(state => state.session.sessionContext);
  const currentUser = useSelector(state => state.session.currentUser);

  const onClose = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (!sessionContext) return;
    if (sessionContext.includes("lausanne_delivery_no_longer_possible")) {
      setDelivery(false);
      setShowModal(true);
    } else if (sessionContext.includes("lausanne_delivery_conditions_update")) {
      setDelivery(true);
      setShowModal(true);
    }
  }, [sessionContext]);

  return (
    <Modal
      show={showModal}
      centered
      animation={false}
      contentClassName={"bye-lausanne-content"}
      className={"bye-lausanne-modal"}
    >
      <StyledByeLausanneModal className={`flex justify-content-center align-items-center flex-direction-column locale-${locale} ${delivery ? "modal-delivery" : "modal-no-delivery"}`} delivery={delivery}>
        <img src={imagePath + "/blob_top_left.svg"} alt="blob" className="blob blob-top"/>
        <button className={"btn-close"} onClick={onClose}>
          <img src={"/icons/thin-cross-white.svg"} alt={"close"}/>
        </button>
        <div className={`content flex flex-direction-column align-items-center content-language-${locale} ${delivery ? "delivery" : "no-delivery"}`}>
          <h1 dangerouslySetInnerHTML={{
            __html:
            delivery
              ? t(`${translationKey}.delivery.title`)
              : t(`${translationKey}.no_delivery.title`)
          }}>
          </h1>
          {
            delivery
              ? <div className={"flex flex-direction-column align-items-center"} dangerouslySetInnerHTML={{
                __html: t(`${translationKey}.delivery.body1`, {
                  link_1: deliveryDetailsLink[locale || "de"],
                  link_2: currentUser?.hasActiveSubscription ? accountFarmyPass : newFarmyPassLink,
                  hide_element: ""
                })
              }}></div>
              : <div className={"margin-top-20 margin-bottom-30"}><p>{t(`${translationKey}.no_delivery.body1`)}</p></div>
          }
        </div>
        <button
          onClick={onClose}
          className={"btn-primary btn-accept margin-top-10"}
        >
          {t(`${translationKey}.cta`)}
        </button>
        <img src={imagePath + "/blob_bottom_right.svg"} alt="blob" className="blob blob-bottom"/>
      </StyledByeLausanneModal>
    </Modal>
  );
};
export default ByeLausanneModal;

const StyledByeLausanneModal = styled.div.attrs({
  className: `
  flex
  justify-content-center
  flex-direction-column
  `
})`
  background-image: url(${props => `${imagePath}/tractor_map_${props.delivery ? "delivery" : "no_delivery"}.svg`});
  background-color: ${theme.colors.primaryColor};
  background-repeat: no-repeat;
  background-size: 98%;
  background-position: center 2%;
  overflow: hidden;
  padding: 144px 20px 40px 20px;
  border-radius: 35px;

  @media(max-width: ${theme.breakPoints.sm}px) {
    background-size: 98%;
    background-position: center 10px;
  }
  @media(max-width: 688px) {
    background-size: 98%;
    background-position: center 10px;
    &.modal-delivery {
      padding-top: 165px;
      background-position: center 30px;
    }
  }
  @media(max-width: 550px) {
    &.modal-no-delivery {
      padding-top: 130px;
      background-position: center 30px;
    }
    &.modal-delivery {
      &.locale-de {
        padding-top: 135px;
      }
    }
  }
  @media(max-width: 450px) {
    background-size: contain;
    &.modal-delivery, &.modal-no-delivery {
      background-position: center 20px;
    }
    &.modal-delivery {
      padding-top: 185px;
      &.locale-de {
        padding-top: 175px;
      }
    }
    &.modal-no-delivery {
      padding-top: 210px;
    }
    background-image: url(${props => `${imagePath}/tractor_map_${props.delivery ? "delivery_mobile" : "no_delivery_mobile"}.svg`});
  }
  @media(max-width: 400px) {
    &.modal-no-delivery {
      &.locale-de {
        padding-top: 165px;
      }
      &.locale-en {
        padding-top: 200px;
      }
    }
  }
  @media(max-width: 380px) {
    background-position: center 30px;
  }
  @media(max-width: 350px) {
    background-position: center 30px;
    &.modal-no-delivery {
      padding-top: 200px;
      &.locale-de {
        padding-top: 165px;
      }
      &.locale-en {
        padding-top: 160px;
      }
    }
  }

  .content {
    text-align: center;
    max-width: 518px;
    width: 100%;
    color: #FFFFFF;
    h1 {
      font-size: 30px;
      color: #FFFFFF;
      max-width: 400px;
      width: 100%;
      font-weight: 700;
    }
    p {
      font-size: 17px;
      a {
        text-decoration: underline;
      }
      .highlight {
        color: #14E850;
      }
    }
    .hide-element {
      display: none;
    }
    &.no-delivery {
      max-width: 400px;
      h1 {
        max-width: 350px;
        font-size: 30px;
      }
    }
    @media(max-width: 500px) {
      max-width: 390px;
      h1 {
        font-size: 26px;
        max-width: 250px;
      }
    }
    &.content-language-de {
      h1 {
        max-width: 370px;
        @media(max-width: 543px) {
          max-width: 300px;
        }
        @media(max-width: 490px) {
          max-width: 230px;
        }
      }
      p:first-child {
        max-width: 450px;
      }
      p:nth-child(2) {
        max-width: 518px;
      }
      p:nth-child(3) {
        max-width: 450px;
      }
      p:last-child {
        max-width: 268px;
      }
      &.no-delivery {
        p:last-child {
          max-width: 418px;
        }
        @media(max-width: 490px) {
          h1 {
            max-width: 270px;
          }
        }
      }
    }
    &.content-language-fr-CH {
      h1 {
        max-width: 370px;
        @media(max-width: 543px) {
          max-width: 300px;
        }
        @media(max-width: 490px) {
          max-width: 230px;
        }
      }
      p:first-child {
        max-width: 454px;
      }
      p:nth-child(2) {
        max-width: 518px;
      }
      p:nth-child(3) {
        max-width: 480px;
      }
      p:last-child {
        max-width: 268px;
      }
      &.no-delivery {
        p:last-child {
          max-width: 368px;
        }
        @media(max-width: 490px) {
          h1 {
            max-width: 270px;
          }
        }
      }
    }
    &.content-language-en {
      h1 {
        max-width: 370px;
        @media(max-width: 543px) {
          max-width: 300px;
        }
        @media(max-width: 490px) {
          max-width: 230px;
        }
      }
      p:first-child {
        max-width: 450px;
      }
      p:nth-child(2) {
        max-width: 490px;
      }
      p:nth-child(3) {
        max-width: 500px;
      }
      p:last-child {
        max-width: 500px;
      }
      &.no-delivery {
        p:last-child {
          max-width: 400px;
        }
        @media(max-width: 490px) {
          h1 {
            max-width: 270px;
          }
        }
      }
    }
  }
  .btn-close {
    border: none;
    background: none;
    padding: 0;
    top: 24px;
    right: 29px;
    position: absolute;
    img {
      height: 20px;
      width: auto;
    }       
  }
  .btn-accept {
    max-width: 215px;
    min-height: 67px;
    width: 100%;
    padding: 10px 20px;
    font-size: 24px;
    font-weight: 700;
    border: none;
    outline: none;
    border-radius: 4px;
    z-index: 500;
  }
  .blob {
    position: absolute;
    height: 100px;
    width: auto;
    &.blob-top {
      top: 0px;
      left: 0;
      ${mediaQuery("sm")`
        top: -20px;
      `};
    }
    &.blob-bottom {
      bottom: 0;
      right: 0;
    }
  }
`;
